var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8351 5.11776C12.9127 4.69692 13.0481 4.24865 13.2599 3.85636C13.6167 3.19571 14.1468 2.75 15 2.75C15.4142 2.75 15.75 2.41421 15.75 2C15.75 1.58579 15.4142 1.25 15 1.25C13.4532 1.25 12.4833 2.13762 11.9401 3.14364C11.6016 3.77041 11.4129 4.46291 11.3215 5.07706C9.99143 5.38458 9 6.57651 9 8C9 6.34315 7.65685 5 6 5C4.34315 5 3 6.34315 3 8C3 9.65685 4.34315 11 6 11C7.65685 11 9 9.65685 9 8C9 9.65685 10.3431 11 12 11C13.6569 11 15 9.65685 15 8C15 9.65685 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8C15 6.63294 14.0856 5.47945 12.8351 5.11776Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C10.6569 16.5 12 15.1569 12 13.5C12 15.1569 13.3431 16.5 15 16.5C16.6569 16.5 18 15.1569 18 13.5C18 11.8431 16.6569 10.5 15 10.5C13.3431 10.5 12 11.8431 12 13.5C12 11.8431 10.6569 10.5 9 10.5C7.34315 10.5 6 11.8431 6 13.5C6 15.1569 7.34315 16.5 9 16.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19C15 20.6569 13.6569 22 12 22C10.3431 22 9 20.6569 9 19C9 17.3431 10.3431 16 12 16C13.6569 16 15 17.3431 15 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrape);
export default __webpack_public_path__ + "static/media/grape.09ee35d74e6140c144f639be29d9a487.svg";
export { ForwardRef as ReactComponent };